import { FormControl, FormGroup, Validators } from '@angular/forms';
import { CustomValidators } from '../../validators/custom-validators.validators';
import { FormulaireCoordonneesBancaires } from './formulaire-coordonnees-bancaires.model';
import { FormulaireCoordonneesBancairesTelephone } from './formulaire-coordonnees-bancaires-telephone.model';
import { TelephoneTypeEnum } from '../telephone-type.enum';

export class FormulaireBancaireBuilder {
  static build(): FormGroup<FormulaireCoordonneesBancaires> {
    return new FormGroup<FormulaireCoordonneesBancaires>({
      utiliserMemeAdresse: new FormControl<boolean | null>(null, [Validators.required]),
      numeroCiviqueNomRue: new FormControl<string>('', [
        Validators.required,
        Validators.maxLength(30),
        CustomValidators.doitAvoirUneSeparation,
        CustomValidators.caracteresAccesDValide,
      ]),
      appartement: new FormControl<string>('', [Validators.maxLength(8), CustomValidators.caracteresAccesDValide]),
      ville: new FormControl<string>('', [Validators.required]),
      province: new FormControl<string>('', [Validators.required]),
      codePostal: new FormControl<string>('', [Validators.required]),
      codePays: new FormControl<string>('', [Validators.required]),
      courriel: new FormControl<string>('', [
        Validators.minLength(6),
        Validators.maxLength(64),
        CustomValidators.texteNonBlanc,
        CustomValidators.courrielBancaireValide,
      ]),
      telephonePrincipal: this.buildTelephone(),
      dateChangement: new FormControl<string>('', [Validators.required]),
    });
  }

  static buildTelephone(): FormGroup<FormulaireCoordonneesBancairesTelephone> {
    return new FormGroup<FormulaireCoordonneesBancairesTelephone>({
      telephone: new FormControl<string>('', [Validators.required, CustomValidators.numeroTelephone]),
      poste: new FormControl<string | null>(null, [Validators.maxLength(4)]),
      typeTelephone: new FormControl<TelephoneTypeEnum | null>(null),
    });
  }

  static buildTelephoneTravail(): FormGroup<FormulaireCoordonneesBancairesTelephone> {
    return new FormGroup<FormulaireCoordonneesBancairesTelephone>({
      telephone: new FormControl<string>('', [Validators.required, CustomValidators.numeroTelephone]),
      poste: new FormControl<string | null>(null, [Validators.maxLength(10)]),
      typeTelephone: new FormControl<TelephoneTypeEnum | null>(null),
    });
  }
}
